module.exports = __webpack_public_path__ + "static/media/Config_cal.710a46b4.png";